import React from 'react';

const Footer = () => {
    const handleRedirect = (url) => {
        window.open(url, '_blank');
    };
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '3rem', maxWidth: '1200px', margin: '0 auto', padding: '0 4rem' }}>
                <div className="footer-section">
                    <h4>About Channelplay</h4>
                    <a href="https://www.channelplay.in/about-us" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.channelplay.in/about-us'); }} style={{ color: 'inherit', textDecoration: 'none' }}>About Us</a>
                    <a href="https://www.channelplay.in/contact-us" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.channelplay.in/contact-us'); }} style={{ color: 'inherit', textDecoration: 'none' }}>Contact Us</a>
                    <a href="https://www.channelplay.in/privacy-policy" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.channelplay.in/privacy-policy'); }} style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</a>
                </div>
                <div className="footer-section">
                    <h4>Connect With Us</h4>
                    <div className="social-links">
                        <a href="https://facebook.com/channelplay" onClick={(e) => { e.preventDefault(); handleRedirect('https://facebook.com/channelplay'); }}><i className="fab fa-facebook"></i></a>
                        <a href="https://www.youtube.com/@channelplayindia" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.youtube.com/@channelplayindia'); }}><i className="fab fa-youtube"></i></a>
                        <a href="https://www.linkedin.com/company/channelplay-limited/" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.linkedin.com/company/channelplay-limited/'); }}><i className="fab fa-linkedin"></i></a>
                        <a href="https://www.instagram.com/channelplay_official/" onClick={(e) => { e.preventDefault(); handleRedirect('https://www.instagram.com/channelplay_official/'); }}><i className="fab fa-instagram"></i></a>
                    </div>
                    <div style={{ marginTop: '1.5rem' }}>
                        <h5 style={{ color: 'white', marginBottom: '0.75rem' }}>Download App</h5>
                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <a 
                                href="https://apps.apple.com/us/app/channelplay-jobs/id6504976441" 
                                onClick={(e) => { e.preventDefault(); handleRedirect('https://apps.apple.com/us/app/channelplay-jobs/id6504976441'); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: '#374151', borderRadius: '0.375rem', color: 'white', textDecoration: 'none' }}
                            >
                                <i className="fab fa-apple"></i>
                                <span style={{ fontSize: '0.875rem' }}>App Store</span>
                            </a>
                            <a 
                                href="https://play.google.com/store/apps/details?id=com.channelplay.jobs" 
                                onClick={(e) => { e.preventDefault(); handleRedirect('https://play.google.com/store/apps/details?id=com.channelplay.jobs'); }}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: '#374151', borderRadius: '0.375rem', color: 'white', textDecoration: 'none' }}
                            >
                                <i className="fab fa-google-play"></i>
                                <span style={{ fontSize: '0.875rem' }}>Play Store</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom" style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <p style={{ margin: 0 }}>&copy; {year} Channelplay Jobs. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
